import { stringify } from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import { EntityTypes } from 'context/entityContext';

import { EventTypes, EventCategories } from 'redux/reducers/subscriptions';
import { sortOrderTypes } from 'types/shared';
import { MAX_LIMIT } from 'config';

interface IAllNotificationsArgs {
  entityIds?: number;
  entityType?: EntityTypes;
  countryIds?: number;
  customerIds?: number;
  eventTypes?: EventTypes;
  eventCategories?: EventCategories;
  eventTimestampFrom?: number;
  eventTimestampTo?: number;
  limit?: number;
  offset?: number;
  sortOrder?: sortOrderTypes;
  sortBy?: 'eventType' | 'eventTimestamp';
}

export default function getAllNotificationsURL(
  args: IAllNotificationsArgs = {}
): string {
  const {
    entityIds,
    entityType,
    countryIds,
    customerIds,
    eventTypes,
    eventCategories,
    eventTimestampFrom,
    eventTimestampTo,
    limit = MAX_LIMIT,
    offset,
    sortOrder,
    sortBy,
  } = args;

  const params = stringify({
    entityIds,
    entityType: entityTypeToApiType(entityType),
    countryIds,
    customerIds,
    eventTypes,
    eventCategories,
    eventTimestampFrom,
    eventTimestampTo,
    limit,
    offset,
    sortOrder,
    sortBy,
  });

  return `/notifications/events?${params}`;
}
